import React, { useState } from 'react'
import { FiHeart } from 'react-icons/fi';
import { FaHeart } from 'react-icons/fa';

const InputResults = ({tweet}) => {
  const [like, setLike] = useState(true)

  return (
    <header className="tweet">
      <div className="tweet__photo">
        <img className="tweet__photo--img" src={tweet.photo || 'https://i.stack.imgur.com/34AD2.jpg'} alt="Profile"/>
      </div>
      <div className="tweet__container">
        <div className="tweet__container-top">
          <span className="tweet__container-top--user">{tweet.userName}</span>
          <span className="tweet__container-top--date">{tweet.date}</span>
        </div>
        <div className="tweet__container-bottom">
          <span className="tweet__container-bottom--text">
            {tweet.content}
          </span>
          <div>
            <button 
              onClick={() => setLike(!like)} 
              className="tweet__container-bottom--btn">
              {like ? <FiHeart /> : <FaHeart className="heart-full" />}
            </button>
          </div>
        </div>
      </div>
    </header>
  )
}

export default InputResults
